import { render, staticRenderFns } from "./product-shopping.vue?vue&type=template&id=36389024&scoped=true&"
import script from "./product-shopping.vue?vue&type=script&lang=js&"
export * from "./product-shopping.vue?vue&type=script&lang=js&"
import style0 from "./product-shopping.vue?vue&type=style&index=0&id=36389024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36389024",
  null
  
)

export default component.exports